
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {authModule, challengeModule, teamModule, teamsState} from '@/utils/store-acessor';
  import {InvitationMode, InvitationsModel, InvitationStatus, TeamModel} from '@/models/team.model';
  import {ChallengeModel} from '@/models/challenge.model';
  import UserCard from '@/components/Shared/UserCard.vue';

  @Component({
    components: {
      UserCard
    }
  })
  export default class TeamPendentInvitations extends Vue {
    @teamModule.Getter('selectedTeam') team!: TeamModel;
    @teamModule.Getter('invitesByModeAndStatuses') invites!: (mode: InvitationMode, status: InvitationStatus) => InvitationsModel[];
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    snackbarVisibility = false;
    snackbarColor: 'green' | 'red' = 'green';
    snackbarText = '';
    acceptLoading = false;
    refuseLoading = false;
    cancelLoading = false;

    async mounted() {

      if (this.team?.slug && this.challenge?.id && this.isAuthenticated) {
        await teamsState.fetchPendingInvites({
          slug: this.team.slug,
          challengeId: this.challenge.id
        });
      }
    }

    async approveInvite(invite: InvitationsModel) {
      this.snackbarVisibility = false;
      if (invite?.id && this.team?.id && this.challenge?.id) {
        try {
          this.acceptLoading = true;
          await teamsState.approveInvite({
            inviteId: invite.id,
            teamId: this.team.id,
            challengeId: this.challenge.id
          });
          this.snackMessage('invites.messages.accepted.success', 'green');
          this.acceptLoading = false;
        } catch (e) {
          this.acceptLoading = false;
          this.snackMessage('invites.messages.accepted.failed', 'red');
        }
      }
    }

    async refuseInvite(invite: InvitationsModel) {
      this.snackbarVisibility = false;
      if (invite?.id && this.team?.id && this.challenge?.id) {
        try {
          this.refuseLoading = true;
          await teamsState.refuseInvite({
            inviteId: invite.id,
            teamId: this.team.id,
            challengeId: this.challenge.id
          });
          this.refuseLoading = false;
          this.snackMessage('invites.messages.refused.success', 'green');
        } catch (e) {
          this.refuseLoading = false;
          this.snackMessage('invites.messages.refused.failed', 'red');
        }
      }
    }

    async cancelInvite(invite: InvitationsModel) {
      this.snackbarVisibility = false;
      if (invite?.id && this.team?.id && this.challenge?.id) {
        try {
          this.cancelLoading = true;
          await teamsState.cancelInvite({
            inviteId: invite.id,
            teamId: this.team.id,
            challengeId: this.challenge.id
          });
          this.cancelLoading = false;
          this.snackMessage('invites.messages.canceled.success', 'green');
        } catch (e) {
          this.cancelLoading = false;
          this.snackMessage('invites.messages.canceled.failed', 'red');
        }
      }
    }

    private snackMessage(message: string, color: 'green' | 'red') {
      this.snackbarVisibility = true;
      this.snackbarColor = color;
      this.snackbarText = message;
    }
  }
